import { Column, Entity, JoinColumn, OneToMany, PrimaryColumn } from "typeorm";
import { Branches } from "./branches.entity";

@Entity('prefectures', { schema: 'public', synchronize: false })
export class Prefecture {
  @PrimaryColumn({ name: 'code', type: 'text' })
  code: string;

  @Column("character varying", { name: "name" })
  name: string;

  @OneToMany(() => Branches, (branch) => branch.prefecture)
  @JoinColumn({ name: 'code' })
  branches?: Branches[];
}
